import { Palette, Info } from "@phosphor-icons/react";
import { SectionShell, ColorSwatch } from "../Primitives";
import { PALETTE } from "@/data/designTokens";

function Group({ title, items }) {
  return (
    <div>
      <h3 className="mb-4 text-sm font-bold uppercase tracking-wider text-muted-foreground">{title}</h3>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {items.map((swatch) => (
          <ColorSwatch key={swatch.varName + swatch.name} swatch={swatch} />
        ))}
      </div>
    </div>
  );
}

export function ColorSection() {
  return (
    <SectionShell
      id="colour"
      eyebrow="Colour"
      eyebrowIcon={Palette}
      title="A warm, optimistic palette"
      description="Warm orange leads, grounded by a friendly white canvas. Yellow, teal and blue add encouragement, growth and calm focus. Tap any swatch to copy it — values update live with the theme."
    >
      <div className="space-y-10">
        <Group title="Primary" items={PALETTE.primary} />
        <Group title="Secondary & accents" items={PALETTE.secondary} />
        <Group title="Neutrals" items={PALETTE.neutral} />
        <Group title="Semantic" items={PALETTE.semantic} />

        <div className="flex items-start gap-4 rounded-3xl border border-border bg-accent/60 p-6">
          <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-2xl bg-primary text-primary-foreground">
            <Info size={20} weight="fill" />
          </span>
          <div>
            <p className="font-display text-lg font-bold">Accessible orange, on purpose</p>
            <p className="mt-1 font-medium leading-relaxed text-muted-foreground">
              The bright orange (<strong className="text-foreground">#FF7A45</strong>) is reserved for fills and large
              bold labels. For orange <em>text</em> on white we shift to a deeper{" "}
              <strong className="text-primary-strong">Primary&nbsp;Strong (#C2410C)</strong> so every word clears the
              WCAG&nbsp;AA 4.5:1 contrast bar.
            </p>
          </div>
        </div>
      </div>
    </SectionShell>
  );
}

export default ColorSection;
